module.exports = __webpack_public_path__ + "static/media/default-skin.b257fa9c.svg";